exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-6216818b!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/status.vue
// module id = 64
// module chunks = 0